module.exports = __webpack_public_path__ + "img/consultative-selling.131ef56b.svg";